import { OrganizationFeature } from './organization';

export enum UserOrganizationAffiliationType {
  Activity = 'Activity',
  Legacy = 'Legacy'
}

export interface IUserOrganization {
  name: string;
  id: string;
  isPrimary: boolean;
  features: OrganizationFeature[];
  affiliationType: UserOrganizationAffiliationType;
  subsidiariesHierarchy: ISubsidiariesOrganization;
  isSubsidiary?: boolean | null;
}

export interface ISubsidiariesOrganization {
  organizationId: string;
  organizationName: string;
  rank: number;
  parentOrganizationId: string | null;
  children: ISubsidiariesOrganization[];
  features: OrganizationFeature[];
}
